import { render, staticRenderFns } from "./SmallDeliveryObject.vue?vue&type=template&id=98951f2e&lang=pug&"
import script from "./SmallDeliveryObject.vue?vue&type=script&lang=ts&"
export * from "./SmallDeliveryObject.vue?vue&type=script&lang=ts&"
import style0 from "./SmallDeliveryObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports